<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item :label="$t('施工公司名称')" prop="constructionName">
              <a-input v-model="model.constructionName" :placeholder="$t('请输入施工公司名称')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('备注信息')" prop="remark">
              <a-textarea v-model="model.remark" :placeholder="$t('请输入')" :rows="4" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue,
    historyFileUrl,
    paramsToFormData
  } from '@/utils/util'

  export default {
    name: 'Form',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        model: {},
        confirmLoading: false,
        url: {
          add: "/jeecg-engineering/engineering/constructionCompany/add",
          edit: "/jeecg-engineering/engineering/constructionCompany/edit",
          queryById: "/jeecg-engineering/engineering/constructionCompany/queryById",
        },
      }
    },
    computed: {
      formDisabled() {
        return this.disabled
      },
      validatorRules() {
        return {
          constructionName:[
            { required: true, message: this.$t('请输入施工公司名称'), trigger: 'change' },
          ]
        }
      },
    },
    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add() {
        this.edit(this.modelDefault);
      },
      edit(record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
<style scoped>
  .avatar-uploader>.ant-upload {
    width: 104px;
    height: 104px;
  }
</style>